import { createGlobalStyle } from "styled-components";

export const editorjs = {
    block_padding: "var(--block-padding)",
};

export const EditorJsVarsStyle = createGlobalStyle`
    :root {
        --block-padding: 0.8em 0;
    }
`;
